export const Quote = () => (
  <svg id="quote-svg" xmlns="http://www.w3.org/2000/svg" viewBox="5 5 14 14">
    <path fill="none" d="M0 0h24v24H0z" />
    <path id="quote-path" d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
  </svg>
);
